import React, { useState, useCallback } from 'react'
import { TextField, InputAdornment } from '@mui/material'
import { useTranslation } from 'react-i18next'
import TemporaryIcon from 'components/global/TemporaryIcon'
import { useDebouncedCallback } from 'use-debounce'

interface SearchFilterProps {
  onChange: (value: string) => void
}

const SearchFilter: React.FC<SearchFilterProps> = ({ onChange }) => {
  const { t } = useTranslation()
  const [searchValue, setSearchValue] = useState('')
  
  const debouncedOnChange = useDebouncedCallback(onChange, 300)

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setSearchValue(value)
    debouncedOnChange(value)
  }, [debouncedOnChange])

  return (
    <TextField
      size="small"
      value={searchValue}
      onChange={handleChange}
      placeholder={t('stats.traffic.search_placeholder')}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <TemporaryIcon iconlabel="magnifying-glass" iconsize="14px" />
          </InputAdornment>
        )
      }}
      sx={{
        width: '100%',
        backgroundColor: '#FFFFFF',
        position: 'sticky',
        top: 0,
        zIndex: 100,
        '& .MuiOutlinedInput-root': {
          fontSize: '12px',
          height: '32px',
          backgroundColor: '#FFFFFF',
          borderRadius: '6px',
          '& fieldset': {
            borderColor: '#EFEFEF',
          },
          '&:hover fieldset': {
            borderColor: '#CCCCCC',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#1976d2',
          },
        },
        '& .MuiInputBase-input': {
          fontSize: '12px'
        }
      }}
    />
  )
}

export default SearchFilter
